/**
 * This function returns the current Phoenix, Arizona time as a `Date` object.
 *
 * - JavaScript `Date` is always stored in UTC,
 *   normally use the system’s local timezone.
 * - `Intl.DateTimeFormat` can format a Date in Phoenix time, but only
 *   gives strings, not a real `Date`.
 *
 * This is how it works:
 * - Extracts Phoenix-local year, month, day, hour, minute, second using
 *   `formatToParts()`.
 * - Builds a new `Date` with those values so `.getHours()` or `.getMinutes()`
 *   will reflect Phoenix time.
 */

export function getPhoenixDate(): Date {
    const now = new Date();

    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Phoenix',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).formatToParts(now);

    const get = (type: string) => parts?.find(p => p.type === type)?.value ?? '0';

    return new Date(
        Number(get('year')),
        Number(get('month')) - 1,
        Number(get('day')),
        Number(get('hour')),
        Number(get('minute')),
        Number(get('second'))
    );
}
